let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cfSLZ")).then(() => parcelRequire('2F3Za'));